import type { CommitmentVersion } from '@festina/life-general-types/life'
import { CommitmentsVersionsService_commitmentVersionsServiceGetEntity } from '@festina/life-general-types/life/hooks/CommitmentsVersionsService_commitmentVersionsServiceGetEntity'

export const useFetchCommitmentVersion =
  CommitmentsVersionsService_commitmentVersionsServiceGetEntity.useSuspenseQuery<CommitmentVersion | null>
